/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Level_SaInputs */



/**
* | output |
* | --- |
* | "SA" |
*
* @param {Sanction_Level_SaInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_level_sa = /** @type {((inputs?: Sanction_Level_SaInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Level_SaInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("SA")
	if (locale === "es") return /** @type {LocalizedString} */ ("SA")
	if (locale === "pt") return /** @type {LocalizedString} */ ("SA")
	if (locale === "it") return /** @type {LocalizedString} */ ("SA")
	return /** @type {LocalizedString} */ ("SA")
});